import { trainingCourseManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const trainingCourseManagementRouteMetadata: IRouteMetadataObj<
  typeof trainingCourseManagementRoutesObj
> = {
  list: {
    title: "trainingCourseManagement.index.title",
    description: "trainingCourseManagement.index.description",
    lazy: () => import("@/pages/trainingCourseManagement/table/page"),
    mode: "index",
    type: "main",
    icon: "GraduationCapLine",
    breadcrumbs: [],
    permission: [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher],
  },
  create: {
    title: "trainingCourseManagement.create.title",
    description: "trainingCourseManagement.create.description",
    lazy: () => import("@/pages/trainingCourseManagement/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission: [IRoleEnum.SUPER_ADMIN],
  },
  edit: {
    title: "trainingCourseManagement.edit.title",
    description: "trainingCourseManagement.edit.description",
    lazy: () => import("@/pages/trainingCourseManagement/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission: [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher, IRoleEnum.ASSISTANT],
  },
  view: {
    title: "trainingCourseManagement.edit.title",
    description: "trainingCourseManagement.edit.description",
    lazy: () => import("@/pages/trainingCourseManagement/form/page"),
    mode: "view",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission: [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher, IRoleEnum.ASSISTANT],
  },
};

export const trainingCourseManagementRoutes = createRoute<
  typeof trainingCourseManagementRoutesObj
>(trainingCourseManagementRoutesObj, trainingCourseManagementRouteMetadata);
